import type {
  AnimationMode,
  AnimationSequence,
} from "@src/features/playback/animation";
import {
  canRenderMatrixSequence,
  canRenderTransform,
} from "@src/features/visualization/render-safety";
import type { Dimension, MatrixFor } from "@src/math/types";

export function canVisualizeAnimation<D extends Dimension>(
  animation: AnimationSequence<D> & {
    readonly totalTransform: Readonly<MatrixFor<D>>;
  },
  mode: AnimationMode,
): boolean {
  if (mode === "composed") return canRenderTransform(animation.totalTransform);
  return canRenderMatrixSequence(
    animation.dimension,
    animation.matrices.map((matrix) => matrix.values),
  );
}
